// ALL OF THESE HELPERS NEED TO DIE A FIRERY DEATH!
// Ext has been deprecated from our system. Alternatives should be used.

Ext.BLANK_IMAGE_URL = '/Images/blank.gif';

// transformSelect serves a single purpose: transforming an select element into a simple extjs combobox...
// not meant to be used for complex ajax loading, etc, just simply a helper method for quickly converting existing selects into styled ones..
const transformSelect = function(id?: (number | string), opts?: {}) {
	const settings: {} = {
		typeAhead: true,
		triggerAction: 'all',
		transform: id,
		id: id,
		editable: false,
		shadow: false,
		width: 200
	};
	const options: {} = Object.assign({}, settings, opts);
	// return new Ext.form.ComboBox(options);
	return new Ext.form.ComboBox(options);
};

const achAccountTypeComboBox = function(field: string, opts: {}) {
	const defaults = {
		typeAhead: true,
		triggerAction: 'all',
		transform: field,
		id: field,
		editable: false,
		shadow: false,
		width: 200,
		listWidth: 200,
		allowBlank: true,
		autoSelect: false,
		emptyText: 'Select',
		blankText: 'Select',
		mode: 'local'
	};
	const options = Object.assign({}, defaults, opts);
	// return new Ext.form.ComboBox(options);
	return new Ext.form.ComboBox(options);
};

Ext.ns('Ext.stores');
Ext.stores = {
	accounts: function(opts: {}) {
		const defaults: {} = {
			root: 'custodies',
			fields: [
				'id',
				'nickname',
				'color',
				'account_id',
				'account_last_four',
				'account_number',
				'DisplayedBalance',
				'account_holder',
				{ name: 'reg_d_warn', type: 'boolean', defaultValue: false },
				{ name: 'reg_d_error', type: 'boolean', defaultValue: false },
				'account_balance',          // Server - see my note below
				'savings_goals',
				'goal_allocation_method',
				'owner',
				'joint',
				{ name: 'can_view_account_balance', type: 'boolean' },
				'external',
				'next_payment_amount_due',
				'next_payment_date',
				'current_loan_payoff_amount',
				'last_statement_balance',   // Sergey: convert to money string disabled to prevent
				'ledger_balance',           // '$' showing up where decimal value is expected
				{ name: 'is_closed_ended_loan_account', type: 'boolean' },
				{ name: 'is_open_ended_loan_account', type: 'boolean' },
				{ name: 'is_auto_loan_account', type: 'boolean' },
				{ name: 'is_credit_card_account', type: 'boolean' },
				{ name: 'is_asset_account', type: 'boolean' },
				{ name: 'is_savings_account', type: 'boolean' },
				{ name: 'is_mortgage_loan_account', type: 'boolean' },
				{ name: 'allow_transfers_out', type: 'boolean' },
				{ name: 'is_external_account', type: 'boolean' },
				{ name: 'is_ach_account', type: 'boolean' },
				{ name: 'ach_offset_in', type: 'integer' },
				{ name: 'ach_offset_out', type: 'integer' },
				{ name: 'is_loan_account', type: 'boolean' },
				{ name: 'allow_ach_in', type: 'boolean' },
				{ name: 'allow_ach_out', type: 'boolean' },
				{ name: 'next_payment_amount_due_includes_past_due_amount', type: 'boolean' },
				'past_due_amount',
				{
					name: 'amount_due', type: 'string',
					convert: function(val: string, row: any) {
						return (!row.next_payment_amount_due_includes_past_due_amount && row.past_due_amount && row.past_due_amount != '')
							? parseFloat(row.next_payment_amount_due) + parseFloat(row.past_due_amount)
							: row.next_payment_amount_due;
					}
				},
				'principle_and_interest_amount',
				{ name: 'is_data_current', type: 'boolean' },
				{ name: 'hide_from_end_user', type: 'boolean' }
			]
		};
		return new Ext.Alkami.ExpansionStore(Object.assign(defaults, opts));
	},
	addresses: function(opts: {}, camelCase: boolean): void { // camelCase is for reverse compat. these fields match the ToJson translate method
		var defaults = {
			root: 'addresses',
			fields: ['Id', 'AddressLine1', 'AddressLine2', 'City', 'State', 'Country', 'PostalCode',
				'IsPrimary', 'DisplayName', 'AddressTypeName', 'CanUpdate', 'DisplayDisabledEditText', 'DisabledEditText', 'AllowInternational',
				'MaxAddressLine1Length', 'MaxAddressLine2Length', 'MaxCityLength', { name: 'CoreIdentifier', type: 'integer' }],
			idProperty: 'Id'
		};

		var options = Object.assign(defaults, opts);
		return new Ext.Alkami.ExpansionStore(options);
	},
	phones: function(opts: {}): void {
		return new Ext.Alkami.ExpansionStore(Object.assign({
			root: 'phones',
			fields: ['Id', 'DisplayName', 'UserId', 'IsPrimary', 'CanReceiveSMS', 'IsConfirmed', 'ValidationKey', 'PhoneNumber', 'PhoneNumberType'],
			idProperty: 'Id'
		}, opts));
	},
	businesses: function(opts: {}): void {
		return new Ext.Alkami.ExpansionStore(Object.assign({
			root: 'businesses',
			fields: ['id', 'name', 'addresses', 'electronic']
		}, opts));
	},
	categories: function(opts: {}): void {
		return new Ext.Alkami.ExpansionStore(Object.assign({
			root: 'transaction_categories',
			fields: ['id', 'name', 'children', 'is_child']
		}, opts));
	},
	types: function(opts: {}): void {
		return new Ext.Alkami.ExpansionStore(Object.assign({
			root: 'transaction_types',
			fields: ['Id', 'Name']
		}, opts));
	},
	customers: function(opts: {}): void {
		return new Ext.Alkami.ExpansionStore(Object.assign({
			root: 'customers',
			fields: ['id', 'name', 'nickname', 'account_id']
		}, opts));
	},
	payees: function(opts: {}): void {
		return new Ext.Alkami.ExpansionStore(Object.assign({
			idProperty: 'id',
			fields: [
				'account_id',
				'allow_expedited',
				'allow_same_day',
				'category_id',
				'electronic',
				'icon',
				'id',
				'last_paid_amount',
				'last_paid_date',
				'name',
				'next_due_amount',
				'next_due_date',
				'nickname'
			]
		}, opts));
	},
	managed_payees: function(opts: {}): void {
		return new Ext.Alkami.ExpansionStore(Object.assign({
			root: 'managed_payees',
			fields: ['id', 'name', 'global'],
			url: '/BillPay/Payees/GetManagedPayees'
		}, opts));
	},
	savings_goals: function(opts: {}): void {
		return new Ext.Alkami.ExpansionStore(Object.assign({
			root: 'savings_goals',
			fields: ['id', 'name', 'icon', { name: 'accumulated', convert: moneyRendererAllowZero }, { name: 'amount', convert: moneyRendererAllowZero }]
		}, opts));
	},
	savings_goal_categories: function(opts: {}): void {
		return new Ext.Alkami.ExpansionStore(Object.assign({
			root: 'savings_goal_categories',
			fields: ['id', 'name']
		}, opts));
	},
	transactions: function(opts: {}): void {
		return new Ext.Alkami.ExpansionStore(Object.assign({
			root: 'transactions',
			fields: [
				'id',
				'date',
				'account_id',
				'check_number',
				'transaction_type',
				'description',
				'transaction_categories',
				{ name: 'amount', dataIndex: 'amount', convert: moneyRenderer },
				'interest_amount',
				'principal_amount',
				'credits',
				'debits',
				'balance',
				'custody_color',
				'pending',
				'payee_id',
				'alert',
				'split',
				'release_date',
				'settlement_date',
				'sso_url'
			],
			remoteSort: true,
			sortInfo: {
				field: 'date',
				direction: 'DESC'
			}
		}, opts));
	}
};
const accountComboBox = function(ds: any, field: string, opts: {}): any {

	return new Ext.Alkami.ResourceComboBox(Object.assign({
		store: ds,
		ctCls: 'accounts-combo-ct',
		cls: 'accounts-combo',
		listClass: 'accounts-list',
		transform: field,
		innerTpl: '<span class="bar account-color-{color}-bg"></span> <h4>{nickname}<tpl if="external"><span class="external"></span></tpl><tpl if="!owner"><span class="shared"></span></tpl></h4> <em>&ndash;{account_number}</em> <tpl if="DisplayedBalance==0 || DisplayedBalance==2"><small>{ledger_balance}</small></tpl><tpl if="DisplayedBalance==1 || DisplayedBalance==3"><small>{account_balance}</small></tpl><br class="clear" />',
		displayField: 'nickname',
		resource: 'account',
		width: 200,
		editable: false
	}, opts));
};
const savingsGoalComboBox = function(ds: any, field: string, opts: {}): void {
	return new Ext.Alkami.ResourceComboBox(Object.assign({
		store: ds,
		transform: field,
		listClass: 'icon',
		innerTpl: '<img src="{icon}" alt="" /> <h4>{name}</h4><small>{accumulated} of {amount}</small><br class="clear" />',
		displayField: 'name',
		resource: 'savings-goal',
		editable: false,
		width: 200
	}, opts));
};
const payeesComboBox = function(ds: any, field: string, opts: {}): void {
	return new Ext.Alkami.ResourceComboBox(Object.assign({
		store: ds,
		transform: field,
		listClass: 'icon',
		innerTpl: '<img src="{icon}" alt="" /> <h4>{nickname}</h4> <h3>{name}</h3>',
		displayField: 'name',
		resource: 'payee',
		width: 200
	}, opts));
};
const addressComboBox = function(ds: any, field: string, opts: {}): void {
	return new Ext.Alkami.ResourceComboBox(Object.assign({
		store: ds,
		transform: field,
		innerTpl: '<h4>{AddressLine1}</h4><h3>{AddressLine2}</h3><br />{City}, {State} {Zip}',
		displayField: 'AddressLine1',
		resource: 'address',
		editable: false,
		width: 200
	}, opts));
};

// ---------- DIALOG HELPERS -------------- //
function handleDialogErrors(data: any): void {
	const formElement = document.querySelector('#modal_form form');
	const resource = formElement.getAttribute('data-resource') || (formElement.id || '').replace(/(new_|edit_)/, '');

	Array.from(formElement.querySelectorAll('.field')).forEach(function(fieldElement) {
		fieldElement.classList.remove('field_with_errors');
	});

	if (!(data.length && data.errors.length)) {
		return;
	}

	displayErrorContainerForForm($(formElement) as JQuery<HTMLElement>); // TODO: refactor this guy to not require jQuery
	Array.from(data.errors).forEach(function(_n, i) {
		const resourceInputElement = document.querySelector(`input[name="${resource}[${i}]"]`);
		const fieldElement = resourceInputElement && resourceInputElement.closest('.field');
		if (fieldElement) {
			fieldElement.classList.add('field_with_errors');
		}
	});

	const errorListElement = formElement.querySelector('.errors ul');
	if (errorListElement) {
		errorListElement.innerHTML = Array.from(data.error_messages).map(function(errorMessage) {
			return `<li>${errorMessage}</li>`;
		}).join('');
	}

}

function defaultOnOpen(opts: any) {
	opts = opts || {};
	bindDecimalFields();
	bindDatepicker(null);
	bindRequiredFields();
	$('#modal_form input:submit').remove();
	if (!opts.skipValidation) {
		var req: JQuery<HTMLFormElement> = $('#modal_form form [required]');
		var rules: {} = {};
		var messages: {} = {};
		req.each(function(): void {
			var $label: JQuery = $('label[for="' + this.id + '"]');
			rules[this.name] = { required: true };
			messages[this.name] = { required: $label.text() + " can't be blank." };
		});
		$('#modal_form form').validate({
			rules: rules,
			messages: messages
		});
	}
};
interface IDeleteDialogOptions {
	url: string;
	success?: Function;
	failure?: Function;
	dataType?: string;
}
function deleteDialog(message: string, options: IDeleteDialogOptions, $row?: JQuery, noCallback?: Function) {
	var ajaxDefaults: any = {
		method: 'DELETE',
		success: function(response: any): void {
			Alkami.FlashBanner.showMessage(response.responseText);
			if ($row)
				$row.fadeOut('normal', function() { $row.remove(); });
		}
	};
	if (options.dataType && options.dataType.toLowerCase() == 'json') {
		if (options.success) {
			var origSuccess: Function = options.success;
			delete options.success;
			options.success = function(response: any) {
				var data: string = response.responseText;
				if ($.isJSON(data))
					data = Ext.decode(data);
				origSuccess.call(response, data, 'success');
			};
		}
		if (options.failure) {
			var origfailure: Function = options.failure;
			delete options.failure;
			options.failure = function(response: any) {
				var data: string = response.responseText;
				if ($.isJSON(data))
					data = Ext.decode(data);
				origfailure.call(response, data, 'failure');
			};
		}
	}
	return new Ext.Alkami.YesNoDialog({
		html: message,
		ajaxOptions: {
			'yes': function() {
				Ext.Ajax.request(Ext.apply(ajaxDefaults, options));
			}, 'no': noCallback
		}
	});
}
function createConfirmDialog(url: string, title: string, options: any): any {
	var settings: {} = {
		id: 'modal_form',
		title: title,
		load: defaultOnOpen, // right now this is the only thing holding us back from removing the createFormDialog method entirely.
		url: url
	};
	return new Ext.Alkami.ConfirmDialog(Ext.apply(settings, options));
}
function createFormDialog(url: string, title: string, options: any): any {
	var settings: {} = {
		id: 'modal_form',
		title: title,
		load: defaultOnOpen, // right now this is the only thing holding us back from removing the createFormDialog method entirely.
		url: url
	};
	return new Ext.Alkami.FormDialog(Ext.apply(settings, options));
}
